__turbopack_context__.v({
  "button": "ErrorPage-module-scss-module__ZXvatG__button",
  "container": "ErrorPage-module-scss-module__ZXvatG__container",
  "containerWrapper": "ErrorPage-module-scss-module__ZXvatG__containerWrapper",
  "link": "ErrorPage-module-scss-module__ZXvatG__link",
  "root": "ErrorPage-module-scss-module__ZXvatG__root",
});
